import './index.css';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CalendlyDialogProvider } from './components/CalendlyDialog';
import { ConsentBanner } from './components/ConsentBanner';
import { PreferredSourceBar } from './components/PreferredSourceBar';
import { ScrollManager } from './components/ScrollManager';
import { usePageMediaPreload } from './hooks/usePageMediaPreload';
import { captureAttributionOnLoad } from './lib/attribution';
import { applyStoredConsent } from './lib/consent';
import { FaqPage } from './pages/FaqPage';
import { HomePage } from './pages/HomePage';
import {
  // AiPrevizPage,
  AiVideoContinuityPage,
  ForAgenciesPage,
  ForCreatorsPage,
  ForEnterprisePage,
  ForFilmmakersPage,
  // ScriptToVideoPage,
} from './pages/Phase2MarketingPages';
import { PricingPage } from './pages/PricingPage';
import { RhapsodyPage } from './pages/RhapsodyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage.tsx';
import { ProductModelsPage } from './pages/ProductModelsPage';
import { ProductScriptPage } from './pages/ProductScriptPage';
import { ProductShotControlPage } from './pages/ProductShotControlPage';
import { ShowreelPage } from './pages/ShowreelPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage.tsx';
import { WhatIsInducePage } from './pages/WhatIsInducePage';
import { NotFoundPage } from './pages/NotFoundPage';
import BlogPage from './pages/blog/BlogPage';
import PostPage from './pages/blog/PostPage';
import UseCaseRoutePage from './pages/use-case/UseCaseRoutePage';
import { ComparisonPage } from './pages/ComparisonPage';
import { UseCaseNavProvider } from './context/UseCaseNavContext';

function PageMediaPreloader() {
  usePageMediaPreload();
  return null;
}

function App() {
  useEffect(() => {
    captureAttributionOnLoad();
    applyStoredConsent();
  }, []);

  return (
    <CalendlyDialogProvider>
      <UseCaseNavProvider>
        <ScrollManager />
        <PageMediaPreloader />
        <ConsentBanner />
        <PreferredSourceBar />
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/what-is-induce" element={<WhatIsInducePage />} />
        <Route path="/rhapsody" element={<RhapsodyPage />} />
        <Route path="/product" element={<Navigate to="/" replace />} />
        <Route path="/product/" element={<Navigate to="/" replace />} />
        <Route path="/product/script-editor" element={<ProductScriptPage />} />
        <Route path="/product/ai-video-continuity" element={<AiVideoContinuityPage />} />
        <Route path="/product/shot-control" element={<ProductShotControlPage />} />
        <Route path="/product/models" element={<ProductModelsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/showreel" element={<ShowreelPage />} />
        <Route path="/for-filmmakers" element={<ForFilmmakersPage />} />
        <Route path="/for-agencies" element={<ForAgenciesPage />} />
        <Route path="/for-enterprise" element={<ForEnterprisePage />} />
        <Route path="/for-creators" element={<ForCreatorsPage />} />
        {/* <Route path="/use-cases/script-to-video" element={<ScriptToVideoPage />} /> */}
        {/* <Route path="/use-cases/ai-video-continuity" element={<Navigate to="/product/ai-video-continuity" replace />} /> */}
        {/* <Route path="/use-cases/ai-previz" element={<AiPrevizPage />} /> */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/vs/:slug" element={<ComparisonPage />} />
        <Route path="/blog/:slug" element={<PostPage />} />
        <Route path="/use-cases/:slug" element={<UseCaseRoutePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </UseCaseNavProvider>
    </CalendlyDialogProvider>
  );
}

export default App;
